<div class="maintenance-scroller" *ngIf="messages.length">
  <div class="ticker-wrap">
    <div class="ticker">
      <div class="ticker__item head">{{message_head}}</div>
      <ng-container *ngFor="let msg of messages">
        <div class="ticker__item">{{msg}}</div>
      </ng-container>
    </div>
  </div>
</div>
